import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { EntCheckpoint } from "../../../../models/handBooks/checkpoint";

export const checkpointApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getCheckpointList: builder.query<ResponseDataGet<EntCheckpoint>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.checkpoint }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getCheckpointById: builder.query<ResponseDataGet<EntCheckpoint>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.checkpoint }/${ id }`,
		method: 'GET',
	  }),
	}),

	addCheckpoint: builder.mutation<ResponseDataGet<EntCheckpoint>, EntCheckpoint>({
	  query: (body) => ({
		url: `${ Paths.handbooks.checkpoint }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editCheckpoint: builder.mutation<ResponseDataGet<EntCheckpoint>, EntCheckpoint>({
	  query: (body) => ({
		url: `${ Paths.handbooks.checkpoint }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteCheckpoint: builder.mutation<ResponseDataGet<EntCheckpoint>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.checkpoint }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetCheckpointListQuery,
  useGetCheckpointByIdQuery,
  useAddCheckpointMutation,
  useEditCheckpointMutation,
  useDeleteCheckpointMutation,
  useLazyGetCheckpointListQuery
} = checkpointApi;
